import React from 'react';
import EditIconDisabled from '../assets/images/EditDisabledIcon.svg';

export default () => {
  return <img src={EditIconDisabled} alt="Edit" />;
};
